import { getToken, getTokenHeader } from '../../../v3/Common/Token';
import { axios } from '../../../utils/settings';
import { getCompanySuppliersUrl, getSearchProductsUrl, moduleWiseEntityUrl, searchCompanyUrl } from '../url';

export const fetchSkuFilterAction = async (searchIndex, queryData) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${getSearchProductsUrl()}?search_index=${searchIndex}&filter=true`,
        queryData,
        { ...getTokenHeader(token) },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const searchCompanyAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        searchCompanyUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};


export const getCompanySuppliersAction = async (
  module = 'default',
  params = {},
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    if (params instanceof URLSearchParams) {
      params.append('module', module);
    } else {
      params = new URLSearchParams(params);
      params.append('module', module);
    }
    await axios
      .get(getCompanySuppliersUrl(), {
        ...getTokenHeader(token),
        params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// Accepts params: { manufacturer_id, module_name }
export const getCompanyEntityAction = async (params = {}) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const urlParams = new URLSearchParams();
    if (params.manufacturer_id) urlParams.append('manufacturer_id', params.manufacturer_id);
    if (params.company_id) urlParams.append('company_id', params.company_id);
    urlParams.append('module_name', params.module_name || 'ALL_MODULES');
    await axios
      .get(moduleWiseEntityUrl(), {
        ...getTokenHeader(token),
        params: urlParams,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};